var map = {
	"./Checkbox.svg": "./src/icons/svg/Checkbox.svg",
	"./DataEase.svg": "./src/icons/svg/DataEase.svg",
	"./PDF.svg": "./src/icons/svg/PDF.svg",
	"./all-msg.svg": "./src/icons/svg/all-msg.svg",
	"./area.svg": "./src/icons/svg/area.svg",
	"./bar-group-stack.svg": "./src/icons/svg/bar-group-stack.svg",
	"./bar-group.svg": "./src/icons/svg/bar-group.svg",
	"./bar-horizontal.svg": "./src/icons/svg/bar-horizontal.svg",
	"./bar-stack-horizontal.svg": "./src/icons/svg/bar-stack-horizontal.svg",
	"./bar-stack.svg": "./src/icons/svg/bar-stack.svg",
	"./bar.svg": "./src/icons/svg/bar.svg",
	"./blue_1.svg": "./src/icons/svg/blue_1.svg",
	"./blue_2.svg": "./src/icons/svg/blue_2.svg",
	"./blue_3.svg": "./src/icons/svg/blue_3.svg",
	"./blue_4.svg": "./src/icons/svg/blue_4.svg",
	"./blue_5.svg": "./src/icons/svg/blue_5.svg",
	"./blue_6.svg": "./src/icons/svg/blue_6.svg",
	"./blue_7.svg": "./src/icons/svg/blue_7.svg",
	"./blue_8.svg": "./src/icons/svg/blue_8.svg",
	"./blue_9.svg": "./src/icons/svg/blue_9.svg",
	"./buddle-map.svg": "./src/icons/svg/buddle-map.svg",
	"./button_right.svg": "./src/icons/svg/button_right.svg",
	"./cancel_release.svg": "./src/icons/svg/cancel_release.svg",
	"./chart-mix.svg": "./src/icons/svg/chart-mix.svg",
	"./custom_sort.svg": "./src/icons/svg/custom_sort.svg",
	"./dark_1.svg": "./src/icons/svg/dark_1.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./data-reference.svg": "./src/icons/svg/data-reference.svg",
	"./database.svg": "./src/icons/svg/database.svg",
	"./dataset-task.svg": "./src/icons/svg/dataset-task.svg",
	"./datasource.svg": "./src/icons/svg/datasource.svg",
	"./db-de.svg": "./src/icons/svg/db-de.svg",
	"./de-api-new.svg": "./src/icons/svg/de-api-new.svg",
	"./de-copy.svg": "./src/icons/svg/de-copy.svg",
	"./de-db-new.svg": "./src/icons/svg/de-db-new.svg",
	"./de-delete.svg": "./src/icons/svg/de-delete.svg",
	"./de-ds-error.svg": "./src/icons/svg/de-ds-error.svg",
	"./de-ds-move.svg": "./src/icons/svg/de-ds-move.svg",
	"./de-ds-rename.svg": "./src/icons/svg/de-ds-rename.svg",
	"./de-ds-trash.svg": "./src/icons/svg/de-ds-trash.svg",
	"./de-ds-warning.svg": "./src/icons/svg/de-ds-warning.svg",
	"./de-excel-new.svg": "./src/icons/svg/de-excel-new.svg",
	"./de-search.svg": "./src/icons/svg/de-search.svg",
	"./de-sql-new.svg": "./src/icons/svg/de-sql-new.svg",
	"./de-union-new.svg": "./src/icons/svg/de-union-new.svg",
	"./de_pwd_invisible.svg": "./src/icons/svg/de_pwd_invisible.svg",
	"./de_pwd_visible.svg": "./src/icons/svg/de_pwd_visible.svg",
	"./dept.svg": "./src/icons/svg/dept.svg",
	"./display-setting.svg": "./src/icons/svg/display-setting.svg",
	"./doc.svg": "./src/icons/svg/doc.svg",
	"./docs.svg": "./src/icons/svg/docs.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./driver-de.svg": "./src/icons/svg/driver-de.svg",
	"./ds-api.svg": "./src/icons/svg/ds-api.svg",
	"./ds-custom.svg": "./src/icons/svg/ds-custom.svg",
	"./ds-db.svg": "./src/icons/svg/ds-db.svg",
	"./ds-excel.svg": "./src/icons/svg/ds-excel.svg",
	"./ds-sql.svg": "./src/icons/svg/ds-sql.svg",
	"./ds-union.svg": "./src/icons/svg/ds-union.svg",
	"./email-task.svg": "./src/icons/svg/email-task.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./exclamationmark.svg": "./src/icons/svg/exclamationmark.svg",
	"./exclamationmark2.svg": "./src/icons/svg/exclamationmark2.svg",
	"./exit-fullscreen.svg": "./src/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./field_location.svg": "./src/icons/svg/field_location.svg",
	"./field_text.svg": "./src/icons/svg/field_text.svg",
	"./field_time.svg": "./src/icons/svg/field_time.svg",
	"./field_value.svg": "./src/icons/svg/field_value.svg",
	"./folder.svg": "./src/icons/svg/folder.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./funnel.svg": "./src/icons/svg/funnel.svg",
	"./gauge.svg": "./src/icons/svg/gauge.svg",
	"./icon-maybe.svg": "./src/icons/svg/icon-maybe.svg",
	"./icon-more.svg": "./src/icons/svg/icon-more.svg",
	"./icon-quicksetting.svg": "./src/icons/svg/icon-quicksetting.svg",
	"./icon_add-entry_outlined.svg": "./src/icons/svg/icon_add-entry_outlined.svg",
	"./icon_bottom-align_outlined.svg": "./src/icons/svg/icon_bottom-align_outlined.svg",
	"./icon_calendar_outlined.svg": "./src/icons/svg/icon_calendar_outlined.svg",
	"./icon_clear_outlined.svg": "./src/icons/svg/icon_clear_outlined.svg",
	"./icon_dialpad_outlined.svg": "./src/icons/svg/icon_dialpad_outlined.svg",
	"./icon_doc-replace_outlined.svg": "./src/icons/svg/icon_doc-replace_outlined.svg",
	"./icon_effects_outlined.svg": "./src/icons/svg/icon_effects_outlined.svg",
	"./icon_info_filled.svg": "./src/icons/svg/icon_info_filled.svg",
	"./icon_info_outlined.svg": "./src/icons/svg/icon_info_outlined.svg",
	"./icon_left_outlined.svg": "./src/icons/svg/icon_left_outlined.svg",
	"./icon_magnify_outlined.svg": "./src/icons/svg/icon_magnify_outlined.svg",
	"./icon_moments-categories_outlined.svg": "./src/icons/svg/icon_moments-categories_outlined.svg",
	"./icon_pc_outlined.svg": "./src/icons/svg/icon_pc_outlined.svg",
	"./icon_pc_outlined_copy.svg": "./src/icons/svg/icon_pc_outlined_copy.svg",
	"./icon_phone_outlined.svg": "./src/icons/svg/icon_phone_outlined.svg",
	"./icon_redo_outlined.svg": "./src/icons/svg/icon_redo_outlined.svg",
	"./icon_right_outlined.svg": "./src/icons/svg/icon_right_outlined.svg",
	"./icon_share-label_outlined.svg": "./src/icons/svg/icon_share-label_outlined.svg",
	"./icon_undo_outlined.svg": "./src/icons/svg/icon_undo_outlined.svg",
	"./icon_yes_outlined.svg": "./src/icons/svg/icon_yes_outlined.svg",
	"./iconfont.svg": "./src/icons/svg/iconfont.svg",
	"./inner-join.svg": "./src/icons/svg/inner-join.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./join-join.svg": "./src/icons/svg/join-join.svg",
	"./label.svg": "./src/icons/svg/label.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./left-join.svg": "./src/icons/svg/left-join.svg",
	"./line-stack.svg": "./src/icons/svg/line-stack.svg",
	"./line.svg": "./src/icons/svg/line.svg",
	"./link-back.svg": "./src/icons/svg/link-back.svg",
	"./link-down.svg": "./src/icons/svg/link-down.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./liquid.svg": "./src/icons/svg/liquid.svg",
	"./lock_closed.svg": "./src/icons/svg/lock_closed.svg",
	"./lock_closed_switch.svg": "./src/icons/svg/lock_closed_switch.svg",
	"./lock_open.svg": "./src/icons/svg/lock_open.svg",
	"./lock_open_back.svg": "./src/icons/svg/lock_open_back.svg",
	"./lock_other_open.svg": "./src/icons/svg/lock_other_open.svg",
	"./log.svg": "./src/icons/svg/log.svg",
	"./map.svg": "./src/icons/svg/map.svg",
	"./map_old.svg": "./src/icons/svg/map_old.svg",
	"./menu.svg": "./src/icons/svg/menu.svg",
	"./more_v.svg": "./src/icons/svg/more_v.svg",
	"./msg-setting.svg": "./src/icons/svg/msg-setting.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./no-join.svg": "./src/icons/svg/no-join.svg",
	"./no_result.svg": "./src/icons/svg/no_result.svg",
	"./non-existent.svg": "./src/icons/svg/non-existent.svg",
	"./none_select.svg": "./src/icons/svg/none_select.svg",
	"./notification.svg": "./src/icons/svg/notification.svg",
	"./page-line.svg": "./src/icons/svg/page-line.svg",
	"./panel-mobile-publish.svg": "./src/icons/svg/panel-mobile-publish.svg",
	"./panel-mobile-unpublished-back.svg": "./src/icons/svg/panel-mobile-unpublished-back.svg",
	"./panel-mobile-unpublished.svg": "./src/icons/svg/panel-mobile-unpublished.svg",
	"./panel-publish.svg": "./src/icons/svg/panel-publish.svg",
	"./panel-unpublished-back.svg": "./src/icons/svg/panel-unpublished-back.svg",
	"./panel-unpublished.svg": "./src/icons/svg/panel-unpublished.svg",
	"./panel.svg": "./src/icons/svg/panel.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./percentage-bar-stack-horizontal.svg": "./src/icons/svg/percentage-bar-stack-horizontal.svg",
	"./percentage-bar-stack.svg": "./src/icons/svg/percentage-bar-stack.svg",
	"./pie-donut-rose.svg": "./src/icons/svg/pie-donut-rose.svg",
	"./pie-donut.svg": "./src/icons/svg/pie-donut.svg",
	"./pie-rose.svg": "./src/icons/svg/pie-rose.svg",
	"./pie.svg": "./src/icons/svg/pie.svg",
	"./plugins-new.svg": "./src/icons/svg/plugins-new.svg",
	"./plugins.svg": "./src/icons/svg/plugins.svg",
	"./pwd_invisible.svg": "./src/icons/svg/pwd_invisible.svg",
	"./pwd_visible.svg": "./src/icons/svg/pwd_visible.svg",
	"./radar.svg": "./src/icons/svg/radar.svg",
	"./read-msg.svg": "./src/icons/svg/read-msg.svg",
	"./reference-field.svg": "./src/icons/svg/reference-field.svg",
	"./reference-play.svg": "./src/icons/svg/reference-play.svg",
	"./reference-setting.svg": "./src/icons/svg/reference-setting.svg",
	"./reference-table.svg": "./src/icons/svg/reference-table.svg",
	"./release.svg": "./src/icons/svg/release.svg",
	"./richTextView.svg": "./src/icons/svg/richTextView.svg",
	"./right-join.svg": "./src/icons/svg/right-join.svg",
	"./role.svg": "./src/icons/svg/role.svg",
	"./round_play.svg": "./src/icons/svg/round_play.svg",
	"./scatter.svg": "./src/icons/svg/scatter.svg",
	"./scene.svg": "./src/icons/svg/scene.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./sort-asc.svg": "./src/icons/svg/sort-asc.svg",
	"./sort-desc.svg": "./src/icons/svg/sort-desc.svg",
	"./sys-param.svg": "./src/icons/svg/sys-param.svg",
	"./sys-relationship.svg": "./src/icons/svg/sys-relationship.svg",
	"./sys-setting.svg": "./src/icons/svg/sys-setting.svg",
	"./sys-tools.svg": "./src/icons/svg/sys-tools.svg",
	"./system.svg": "./src/icons/svg/system.svg",
	"./table-info.svg": "./src/icons/svg/table-info.svg",
	"./table-normal.svg": "./src/icons/svg/table-normal.svg",
	"./table-pivot.svg": "./src/icons/svg/table-pivot.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./task.svg": "./src/icons/svg/task.svg",
	"./text.svg": "./src/icons/svg/text.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./treemap.svg": "./src/icons/svg/treemap.svg",
	"./unpublished.svg": "./src/icons/svg/unpublished.svg",
	"./unread-msg.svg": "./src/icons/svg/unread-msg.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./warn-tree.svg": "./src/icons/svg/warn-tree.svg",
	"./waterfall.svg": "./src/icons/svg/waterfall.svg",
	"./web-msg.svg": "./src/icons/svg/web-msg.svg",
	"./wizard_enterprise.svg": "./src/icons/svg/wizard_enterprise.svg",
	"./wizard_help.svg": "./src/icons/svg/wizard_help.svg",
	"./wizard_main_bg_inner.svg": "./src/icons/svg/wizard_main_bg_inner.svg",
	"./wizard_quick_start.svg": "./src/icons/svg/wizard_quick_start.svg",
	"./word-cloud.svg": "./src/icons/svg/word-cloud.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";